var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 19.9648H17.4",
    stroke: "#277154",
    style: (_ref2 = {
      stroke: "#277154"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1529 0.4431 0.3294)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8989 3.46179L12.5667 2.79399C12.8297 2.53108 13.1419 2.32253 13.4854 2.18027C13.829 2.038 14.1972 1.9648 14.5691 1.96484C14.9409 1.96489 15.3092 2.03817 15.6527 2.18051C15.9962 2.32285 16.3084 2.53147 16.5713 2.79444C16.8342 3.05741 17.0427 3.36959 17.185 3.71316C17.3273 4.05673 17.4005 4.42495 17.4004 4.79681C17.4004 5.16866 17.3271 5.53687 17.1848 5.88041C17.0424 6.22394 16.8338 6.53608 16.5708 6.79899L15.903 7.46499M11.8989 3.46179C11.8989 3.46179 11.9826 4.88019 13.2336 6.13119C14.4846 7.38219 15.903 7.46499 15.903 7.46499M11.8989 3.46179L5.76363 9.59709C5.34783 10.0129 5.13993 10.2199 4.96172 10.4494C4.75063 10.7195 4.56984 11.0119 4.42262 11.3215C4.29752 11.5834 4.20483 11.8624 4.01853 12.4195L3.23103 14.7829M15.903 7.46499L9.76773 13.6012C9.35193 14.017 9.14493 14.224 8.91543 14.4031C8.64483 14.6143 8.35413 14.794 8.04333 14.9422C7.78143 15.0673 7.50242 15.16 6.94532 15.3454L4.58193 16.1338M3.23103 14.7829L3.03933 15.3598C2.99439 15.4943 2.98782 15.6387 3.02036 15.7767C3.0529 15.9148 3.12325 16.041 3.22354 16.1413C3.32382 16.2416 3.45006 16.3119 3.5881 16.3445C3.72614 16.377 3.87051 16.3704 4.00503 16.3255L4.58193 16.1338M3.23103 14.7829L4.58193 16.1338",
    stroke: "#277154",
    style: (_ref3 = {
      stroke: "#277154"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1529 0.4431 0.3294)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.35
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6fbb14a3.svg";
export { ForwardRef as ReactComponent };